import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { environment } from 'src/environments/environment';
import { DeleteAccessoriesProductModel, UpdateAccessoriesProduct } from '../models/product/accessories.model';
import { AddProductModel, AddProductVm, SearchTagsModel } from '../models/product/addProduct.model';
import { GetProductAssetDeleteModel, GetProductAssetModel, GetProductAssetSequence, GetProductAssetSequenceModel } from '../models/product/productAssets.modal';
import { ProductListingModel } from '../models/product/productListing.modal';
import { DeleteRelatedProductModel, UpdateRelatedProduct } from '../models/product/relatdProduct';
import { UploadFileModel } from '../models/product/uploadFile.model';
import { ApiService } from './Common/api.service';
import { LocalstorageService } from './Common/localstorage.service';
import { UrlHelperService } from './Common/urlhelper.service';

@Injectable({
  providedIn: 'root'
})
export class ProductService {

  constructor(private _api: ApiService, private httpClient: HttpClient, private localStorage: LocalstorageService) { }

  getCategories() {
    return this._api.post(UrlHelperService.getAllCategories);
  }

  addProduct(addProduct: AddProductVm) {
    return this._api.post(UrlHelperService.addProduct, addProduct)
  }

  productListing(productlist: ProductListingModel) {
    return this._api.post(UrlHelperService.productListing, productlist)
  }

  getProductById(id) {
    return this._api.post(UrlHelperService.getProductbyid + id);
  }

  updateProduct(updateProductList: AddProductModel) {
    return this._api.post(UrlHelperService.updateProductListing, updateProductList);
  }

  uploadimage(uploadFileModel: UploadFileModel) {
    let formData = new FormData();
    formData.append('file', uploadFileModel.Image, uploadFileModel.Image.name);
    var queryParams = {
      FileDescription: uploadFileModel.FileDescription == undefined || uploadFileModel.FileDescription == null ? '' : uploadFileModel.FileDescription,
      FileTitle: uploadFileModel.FileTitle == undefined || uploadFileModel.FileTitle == null ? '' : uploadFileModel.FileTitle
    }
    return this.httpClient.post(environment.apiUrl + UrlHelperService.uploadImage + uploadFileModel.ProductId, formData, { params: queryParams, headers: { 'Authorization': this.localStorage.getToken() } });
    // return this._api.post(UrlHelperService.uploadImage, formData);
  }

  productAssetsListing(productModel: GetProductAssetModel){
      return this._api.post(UrlHelperService.productImageListing, productModel);
  }

  productAssetsThumbnail(productThumbnailModel: GetProductAssetModel) {
     return this._api.post(UrlHelperService.productSingleThumbnail, productThumbnailModel);
  }

  productListingDelete(productDeleteModel: GetProductAssetDeleteModel){
    return this._api.post(UrlHelperService.productDeleteListing, productDeleteModel);
}

  getProductId = new BehaviorSubject(<string>'');
  passProductId(productId) {
    this.getProductId.next(productId);
  }

  getFileType = new BehaviorSubject(<string>'');
  passFileType(fileType) {
    this.getFileType.next(fileType);
  }

  getAllCompanyAddress() {
    return this._api.post(UrlHelperService.getAllCompanyAddress);
  }
  
 releatedProductsListing(productlist: ProductListingModel) {
    return this._api.post(UrlHelperService.relatedProductListing, productlist)
  }

  updateRelatedProducts(updateProductWarrantyService: UpdateRelatedProduct) {
    return this._api.post(UrlHelperService.updateRelatedProducts, updateProductWarrantyService);
  }

  getRelatedProductId(productId) {
    return this._api.post(UrlHelperService.getRelatedProductbyid + productId);
  }

  DeleteRelatedProducts(deleteRelatedProducts: DeleteRelatedProductModel) {
    return this._api.post(UrlHelperService.deleteRelatedProduct, deleteRelatedProducts)
  }

  searchTagsListing(searchTagsListing: SearchTagsModel) {
    return this._api.post(UrlHelperService.searchTagsListEndPoint, searchTagsListing)
  }

  productAssetsBySequenceListing(updateSequenceModel:GetProductAssetSequenceModel){
    return this._api.post(UrlHelperService.productImageUpdateSequenceListing, updateSequenceModel);
  }

  accessoriesProductsListing(productlist: ProductListingModel) {
    return this._api.post(UrlHelperService.accessoriesProductListing, productlist)
  }

  updateAccessoriesProducts(updateAccessoriesProduct: UpdateAccessoriesProduct) {
    return this._api.post(UrlHelperService.updateAccessoriesProducts, updateAccessoriesProduct);
  }

  getAccessoriesProductId(productId) {
    return this._api.post(UrlHelperService.getAccessoriesProductbyid + productId);
  }

  DeleteAccessoriesProducts(deleteAccessoriesProducts: DeleteAccessoriesProductModel) {
    return this._api.post(UrlHelperService.deleteAccessoriesProduct, deleteAccessoriesProducts)
  }
}
